// Dependencies: React, SeletorCustom.css
import React from 'react';
import { FormControl, Select, MenuItem, InputLabel } from '@mui/material';

const SeletorCustom = ({ options, onChange, value, label, transformValues }) => {
    return (
        <div className="parcelas-class">
           <FormControl margin='normal' fullWidth>
            <InputLabel margin='normal' id="demo-simple-select-label">{label}</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={value}
                label={label}
                onChange={onChange}
                margin='normal'
                >
                {options.map((option, index) => (
                    <MenuItem key={index} value={option}>{transformValues(option, (index + 1))}</MenuItem>
                ))}
            </Select>
            </FormControl>
        </div>
    );
};

export default SeletorCustom;
